import React, { FC, Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './Breadcrumbs.module.scss';
import { v4 as uuid } from 'uuid';
import { PropertyType } from '../../../common';

interface BreadcrumbsProps {
	pages: PropertyType[];
}

const Breadcrumbs: FC<BreadcrumbsProps> = ({ pages }) => {
	const history = useHistory();

	const onPageOpen = (page: PropertyType) => {
		history.push(page.value);
	};

	const renderArrow = (shouldRender: boolean) => {
		if (shouldRender) return <span className={styles.Arrow}>{`>`}</span>;
	};

	const renderBreadcrumbs = () =>
		pages.map((p, i) => (
			<Fragment key={uuid()}>
				<h4 onClick={() => onPageOpen(p)} className={styles.Page} data-testid={`bread-${p.value}`}>
					{p.label}
				</h4>
				{renderArrow(i < pages.length - 1)}
			</Fragment>
		));

	return <section className={styles.Breadcrumbs}>{renderBreadcrumbs()}</section>;
};

export { Breadcrumbs };
